import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  files: [],
  totalSize: 0,
  totalUploaded: 0,
  status: {},
  errors: {},
  isFileUploaded: false,
  invoicesUploadSuccessfully: false,
};

const randomId = (length = 6) => {
  return Math.random()
    .toString(36)
    .substring(2, length + 2);
};

const uploadingFileSlice = createSlice({
  name: "uploading",
  initialState: initialState,
  reducers: {
    add(state, action) {
      action.payload.forEach((file) => {
        let fileId = randomId().toString();
        state.files.push({ id: fileId, file: file, size: file.size });
        state.totalSize += file.size;
        state.status = { ...state.status, [fileId]: "pending" };
      });
    },
    remove(state, action) {
      state.files = state.files.filter((file) => file.id !== action.payload);
      state.totalSize = state.files
        .map((file) => file.size)
        .reduce((total, item) => total + item, 0);
    },
    reset() {
      return initialState;
    },
    resetTotalUploaded(state) {
      state.totalUploaded = 0;
    },
    uploadFile(state, action) {
      state.totalUploaded += action.payload;
    },
    changeStatus(state, action) {
      state.status[action.payload.id] = action.payload.status;
    },
    addErrors(state, action) {
      state.errors = {
        ...state.errors,
        [action.payload.id]: action.payload.message,
      };
    },
    setIsFilesUploaded(state) {
      state.isFileUploaded = true;
    },
    setInvoicesUploadSuccessfully(state) {
      state.invoicesUploadSuccessfully = true;
    },
  },
});

export const {
  add,
  remove,
  reset,
  resetTotalUploaded,
  uploadFile,
  changeStatus,
  addErrors,
  setIsFilesUploaded,
  setInvoicesUploadSuccessfully,
} = uploadingFileSlice.actions;
export default uploadingFileSlice.reducer;
